
import useGetQueryPagination from "./helper/ueGetPagination";
import useAddMutation from "./helper/useAddMutation"
import useDeleteMutation from "./helper/useDeleteMutation"
import useGetOneQuery from "./helper/useGetOneQuery";
import useUpdateMutationById from "./helper/useUpdateMutationById";
  
const API = {
  ADD: `SupportMessages`,
  GET_ALL: `supportMessages`,
  DELETE: `SupportMessages`,
  UPDATE: `SupportMessages`,

};
const KEY = "support_messages"


export const useGetSupportMessages = (params?:any) => useGetQueryPagination(KEY, API.GET_ALL,params);
export const useGetOneSupportMessages = () => useGetOneQuery(KEY, API.GET_ALL);

export const useAddSupportMessages = () => useAddMutation(KEY, API.ADD);
export const useUpdateSupportMessages = () => useUpdateMutationById(KEY, API.UPDATE);

export const useDeleteSupportMessages = () =>useDeleteMutation(KEY, API.DELETE);
